var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLightEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 111,
    viewBox: "0 0 81 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9773 0L80.9297 20.5971V110.476H0.929688V0H59.9773Z",
    fill: "#E9EAEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9297 20.9524H59.9773V0L80.9297 20.9524Z",
    fill: "#EF6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3523 20.9521H33.3047V24.7617H12.3523V20.9521Z",
    fill: "#EF6C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 34.286H69.5078V38.0955H12.365V34.286Z",
    fill: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9795 46.9524H54.7891V51.0952H11.9795V46.9524Z",
    fill: "#EF6C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 60.9528H69.5078V64.7623H12.365V60.9528Z",
    fill: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9795 74.5714H54.7891V78.7143H11.9795V74.5714Z",
    fill: "#EF6C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 87.6194H69.5078V91.4289H12.365V87.6194Z",
    fill: "#D0D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLightEmptyImg);
export default __webpack_public_path__ + "static/media/searchLightEmptyImg.9561a6d3c223b26dc7fdf788b12fb298.svg";
export { ForwardRef as ReactComponent };